import React from 'react';
import { bindActionCreators, } from 'redux';
import { connect, } from 'react-redux';
import * as ParcelAction from '../../actions/ParcelAction';
import { Link, } from 'react-router';
import LinesEllipsis from 'react-lines-ellipsis'
//import DownloadLink from 'react-download-link';
//import ImageDownloader from '../../../node_modules/react-native-imagedownloader/ImageDownLoader';
import { numbersWithComma, maskLocationName } from '../../utils/utils';
import { ReactImageMagnify, } from 'react-image-magnify';
import { Modal } from 'react-bootstrap';
import $ from 'jquery';
import '../../../public/css/media/_parcel.scss';
import CartTutorial from '../Tutorial';

import VASIcon from '../../../public/img/icons/vas.svg';

const createReactClass = require('create-react-class');
const Parcel = createReactClass({

  getInitialState: function () {

    return {
      showModalImage: false,
      image: null,
      imageList: null,
      showModalDamage: false,
      upcItemNote: null
    }
  },

  componentWillMount() {
    this.props.getParcelById(this.props.params.id);
  },

  componentDidMount() {
    window.scrollTo(0, 0)
    $('.cart').addClass('active')

  },

  componentDidUpdate(prevProps){
    if (prevProps.params.id !== this.props.params.id){
      this.props.getParcelById(this.props.params.id);
    }
  },

  componentWillReceiveProps(nextProps) {
    this.setState({ image: nextProps.parcelInfo.fetched ? nextProps.parcelInfo.parcel.data.images[0] : null, });
    if (nextProps.parcelInfo.parcel && nextProps.parcelInfo.parcel.data){
      const data = nextProps.parcelInfo.parcel.data.images;
      this.setState({ imageList: data })
    }
    $('#SCTitle').text(nextProps.params.id+" | ShippingCart");
  },

  componentWillUnmount() {
    $('.cart').removeClass('active')
  },

  showModal(name, text) {
    this.setState({ [name]: true, upcItemNote: text });
  },

  close(name) {
    this.setState({ [name]: false, upcItemNote: null });
  },

  handleImage(item) {
    // const image = this.state.imageList ? this.state.imageList[id] : this.props.parcelInfo.parcel.data.images[id]
    this.setState({ image: item });

  },
  handleDate(date) {

    if (date) {
      var sliced_date = date.slice(0, 10);
      var split_date = sliced_date.split("-");
      var new_date = split_date[1] + "/" + split_date[2] + "/" + split_date[0].substring(2, 4)

      return new_date;
    }
    else { return null; }
  },

  download (imageLink) {
    return (
      fetch(`${imageLink}?image`, {
        method: "GET",
        headers: {}
      })
        .then(response => {
          response.arrayBuffer().then(function (buffer) {
            const url = window.URL.createObjectURL(new Blob([buffer]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", imageLink.slice((imageLink.lastIndexOf("/") - 1 >>> 0) + 2)); //or any other extension
            document.body.appendChild(link);
            link.click();
          });
        })
        .catch(err => {
          console.log(err);
        })
    )
  },

  render() {

    return (
      <div>
        <CartTutorial type="item_tutorial" accountDetails={this.props.login.login && this.props.login.login.party}/>
        {
          this.props.parcelInfo.error && this.props.parcelInfo.error.response ?
            this.props.parcelInfo.error.response.data.errors.detail === "Parcel does not exist." ?
              <div className="sc-alert sc-alert-danger2"><i className="sc"></i>Oops! This item is no longer in your cart.</div>
            : null
          : null
        }

        {this.props.parcelInfo.fetching ? null : this.props.parcelInfo.fetched ?


          <div className="body-wrapper">

            <section className="customer item storage-item-detail">

              <div className="customer-wrapper clearfix">



                <div className="main" role="main">
                  <div className="main-content">
                    <div className="back">
                    <span>&#60;</span><Link to="/cart">Back</Link>
                    </div>

                    <div className="item-wrapper">
                      <h3 className="item-name">
                        {this.props.parcelInfo.parcel.data.tracking_number}
                        {
                          (this.props.parcelInfo.parcel.data.flags.vas_status === 'PENDING' || this.props.parcelInfo.parcel.data.flags.vas_status === 'VAS_APPROVED') && 
                          <div className="fa special-handling-icon fa-fw" style={{
                            marginLeft: '10px'
                          }}>
                          <img src={VASIcon} alt="VAS icon" />
                          <div className="tooltip special-handling-tooltip white">
                              <p>This item has an active request.</p>
                            </div>
                          </div>
                        }
                      </h3>
                    </div>
                    <div className="item-detail-wrapper clearfix">
                      {Number(this.props.parcelInfo.parcel.data.flags.special_handling) === 1 && !this.props.parcelInfo.parcel.data.flags.off_size && <div className='parcel-special-handling-wrapper'>
                        <span className='parcel-special-handling-icon fa special-handling-icon fa-fw'/>
                        <p style={{margin: '0px', width: '100%'}}>This package requires special handling.</p>
                        <a href="/special-handling" target="_blank" ><i className="fa fa-angle-right fa-lg icon-angle-right" style={{ float: 'right', color:'#0375D9'}} aria-hidden="true" /> </a>
                      </div>}
                      {Number(this.props.parcelInfo.parcel.data.flags.off_size) === 1 && <div className='parcel-special-handling-wrapper'>
                        <span className='parcel-special-handling-icon fa icon-offsize fa-fw'/>
                        <p style={{margin: '0px', width: '100%'}}>This package is identified as off-size.</p>
                        <a href="https://help-center.shippingcart.com/hc/en-us/articles/7540606985103-Why-is-my-package-tagged-as-off-size-" target="_blank" rel="noopener noreferrer"><i className="fa fa-angle-right fa-lg icon-angle-right" style={{ float: 'right', color:'#0375D9'}} aria-hidden="true" /> </a>
                      </div>}
                      <ul className="thumbnails">

                        {/*MAPPING FOR THUMBNAIL IMAGES*/}

                        {this.state.imageList ? this.state.imageList.map((item, i) => 
                          <li className="active" key={i}>
                            <a className="select-image"
                              data-do="select-item-image" data-on="click" onClick={() => this.handleImage(item)}>
                              <img src={item.image ? item.image : item} alt="" />
                            </a>
                          </li>

                        ) : null}

                      </ul>
                      <div className="item-content">
                        <div data-do="image-modal" className="item-content-wrapper clearfix">
                          <figure className="active-item-image">
                            <div id="zoomImage" onClick={() => this.showModal("showModalImage")}>
                              {this.state.image ?
                                <ReactImageMagnify {...{
                                  largeImage: {
                                    alt: '',
                                    src: this.state.image,
                                    width: 700,
                                    height: 850,
                                  },
                                  smallImage: {
                                    alt: '',
                                    src: this.state.image,
                                    isFluidWidth: true,
                                  },
                                  enlargedImageContainerClassName: "parcel-zoom-container",
                                  lensStyle: {
                                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                                  }
                                }} />
                              : null}
                            </div>

                            <Modal show={this.state.showModalImage} onHide={() => this.close("showModalImage")} autoFocus={true}>
                              <Modal.Header closeButton>
                              </Modal.Header>
                              <Modal.Body>
                                <img className="imgwd100" src={this.state.image} alt="" />
                              </Modal.Body>
                              <Modal.Footer>
                              </Modal.Footer>
                            </Modal>
                            
                              <div className="item-name" style={{ display: 'flex', justifyContent: 'space-between', margin: '5px' }}>
                                <div>{this.props.parcelInfo.parcel.data.description}</div>
                                <div onClick={ async () => await this.download(this.state.image && (this.state.image.image || this.state.image))} className="download-image" style={{ width: '50%', textAlign: 'right', cursor: 'pointer', color: 'blue' }} >Download Image</div>
                              </div>
                              <div className="upc-wrapper">
                                <div className="upc-title">
                                    Item Description
                                </div>
                                <div className="upc-item-wrapper">
                                  {this.props.parcelInfo.parcel.data && this.props.parcelInfo.parcel.data.upc_items.length > 0 ?
                                   this.props.parcelInfo.parcel.data.upc_items.map(item => (
                                  <div className="upc-item-content">
                                    {item.is_damaged ? (
                                      <div style={{padding: '5px 0px 0px'}}>
                                        <i className="fa icon-damaged fa-fw" onClick={() => this.showModal("showModalDamage", item.notes)} />
                                      </div>
                                    ) : (
                                      <span style={{ marginLeft: '20px' }} />
                                    )}
                                    <div className="upc-items">
                                      <div className="upc-item-quantity">{`x${item.no_of_items}`}</div>
                                      <LinesEllipsis
                                        text={item.description}
                                        maxLine='2'
                                        ellipsis=' ...'
                                        trimRight
                                        basedOn='letters'
                                        />
                                    </div>
                                  </div>
                                  )) : (
                                    <div className="upc-item-content">
                                      <span style={{ marginLeft: '20px' }} />
                                      <div className="upc-items">
                                        <LinesEllipsis
                                          text={this.props.parcelInfo.parcel.data.description}
                                          maxLine='2'
                                          ellipsis=' ...'
                                          trimRight
                                          basedOn='letters'
                                          />
                                    </div>
                                  </div>)
                                  }
                                </div>
                              </div>
                          </figure>
                          <Modal 
                            onHide={() => this.close("showModalDamage")}
                            show={this.state.showModalDamage}
                            autoFocus={true}
                            >
                            <Modal.Header closeButton>
                            </Modal.Header>

                            <Modal.Body>
                              <div style={{display: 'flex', backgroundColor: '#FEF6E7', border: '1px solid #FEAB10', padding: '10px', marginBottom: '20px', borderRadius: '4px' }}>
                                <div style={{alignSelf: 'center', marginRight: '8px'}}><i className="fa icon-damaged fa-fw" style={{backgroundSize: 'contain'}}/></div>
                                <div>This package contains damaged items which are excluded from SC Protect when you checkout.</div>
                              </div>

                              <div style={{fontSize: '16px', fontWeight: 600, marginBottom: '6px'}}>Note from the warehouse</div>
                              <div style={{display: 'flex', alignItems: 'center'}}>
                                {this.state.upcItemNote ? this.state.upcItemNote : 'The item received damaged.'}
                              </div>
                            </Modal.Body>
                            <Modal.Footer>
                            </Modal.Footer>
                          </Modal>
                          <div className="details">
                            <table className="item-list-details">
                              <tbody>
                              <tr>
                                <td>From:</td>
                                <td>
                                  {maskLocationName(this.props.parcelInfo.parcel.data.warehouse_country)+ " Warehouse"}
                                </td>
                              </tr>
                              <tr>
                                <td>Date Added<br /> in storage:</td>
                                <td>
                                  {this.handleDate(this.props.parcelInfo.parcel.data.updated_at_warehouse)}
                                </td>
                              </tr>
                              <tr>
                                <td>Shop:</td>
                                <td>{this.props.parcelInfo.parcel.data.origin}</td>
                              </tr>
                              <tr>
                                <td>From {this.props.parcelInfo.parcel.data.courier}#:</td>
                                <td>{this.props.parcelInfo.parcel.data.tracking_number}</td>
                              </tr>
                              <tr>
                                <td>Dimensions:</td>
                                <td>
                                  {this.props.parcelInfo.parcel.data.dimensions.volume.length} x {this.props.parcelInfo.parcel.data.dimensions.volume.width} x {this.props.parcelInfo.parcel.data.dimensions.volume.height} {this.props.parcelInfo.parcel.data.dimensions.volume.uom === "in" ? "inch" : this.props.parcelInfo.parcel.data.dimensions.volume.uom}
                                </td>
                              </tr>
                              <tr>
                                <td>Actual Weight:</td>
                                <td>{this.props.parcelInfo.parcel.data.dimensions.weight.weight} {this.props.parcelInfo.parcel.data.dimensions.weight.uom === "lb" ? "lbs" : this.props.parcelInfo.parcel.data.dimensions.weight.uom}</td>
                              </tr>
                              <tr>
                                <td>Chargeable<br /> Weight:</td>
                                <td>{this.props.parcelInfo.parcel.data.storage.chargeable_weight} {this.props.parcelInfo.parcel.data.dimensions.weight.uom === "lb" ? "lbs" : this.props.parcelInfo.parcel.data.dimensions.weight.uom}</td>
                              </tr>
                              </tbody>
                            </table>

                            <div className="storage-meter">
                              <div className="storage-meter-header clearfix">
                                <h3 className="title">Cart Storage Meter</h3>
                                <div className="storage-status">
                                  <span className="status-label">Total Fee</span>
                                  <span className="status">

                                    {this.props.parcelInfo.parcel.data.storage.excess_charge === "0.00" ? "FREE" : "USD " + numbersWithComma(this.props.parcelInfo.parcel.data.storage.excess_charge.toFixed(2))}

                                  </span>
                                </div>
                              </div>
                              <div className="content">
                                <strong className="countdown">
                                  {this.props.parcelInfo.parcel.data.storage.total_days} days in your Storage
                                                 </strong>

                                <div className="storage-progress">
                                  <div className="progress">

                                    {parseInt(this.props.parcelInfo.parcel.data.storage.total_days,10) === 0 ? <div className="progress hide" /> : (parseInt(this.props.parcelInfo.parcel.data.storage.total_days,10) < (parseInt(this.props.parcelInfo.parcel.data.storage.max_days,10) - parseInt(this.props.parcelInfo.parcel.data.storage.max_day_threshold,10))) || this.props.parcelInfo.parcel.data.flags.free_storage ? <div className="progress-bar free-phase" style={{ width: (this.props.parcelInfo.parcel.data.storage.total_days / this.props.parcelInfo.parcel.data.storage.max_days) * 100 + 5 + "%", }} />
                                    : null}
                                    {parseInt(this.props.parcelInfo.parcel.data.storage.total_days,10) >= (parseInt(this.props.parcelInfo.parcel.data.storage.max_days,10) - parseInt(this.props.parcelInfo.parcel.data.storage.max_day_threshold,10)) && parseInt(this.props.parcelInfo.parcel.data.storage.total_days,10) < parseInt(this.props.parcelInfo.parcel.data.storage.max_days,10) && !this.props.parcelInfo.parcel.data.flags.free_storage ? <div className="progress-bar first-phase" style={{ width: (this.props.parcelInfo.parcel.data.storage.total_days / this.props.parcelInfo.parcel.data.storage.max_days) * 100 + 3 + "%", }} />
                                    : null }
                                    {(parseInt(this.props.parcelInfo.parcel.data.storage.total_days,10) >= this.props.parcelInfo.parcel.data.storage.max_days) && !this.props.parcelInfo.parcel.data.flags.free_storage ? <div className="progress-bar last-phase" style={{ width: (this.props.parcelInfo.parcel.data.storage.total_days / this.props.parcelInfo.parcel.data.storage.max_days) * 100 + "%", }} />
                                    : null }

                                  </div>
                                  <ul className="number-of-days">
                                    <li>Day 1</li>
                                    <li className="current-day"
                                      style={{ left: (this.props.parcelInfo.parcel.data.storage.days_free / this.props.parcelInfo.parcel.data.storage.max_days) * 100 + "%", }}>
                                    </li>
                                    <li className="day90">Day {this.props.parcelInfo.parcel.data.storage.max_days}</li>
                                  </ul>
                                </div>

                                <p className="about-storage">
                                  The {this.props.parcelInfo.parcel.data.storage.days_free}-day free storage starts when your package has been processed and posted to your cart. All packages over {this.props.parcelInfo.parcel.data.storage.max_days} days will be removed from your cart and disposed of at our discretion according to <Link to="/terms-conditions">Section 5-d</Link> of the Terms and Conditions. Please ship out your packages within the {this.props.parcelInfo.parcel.data.storage.max_days}-day period to avoid any inconvenience.
                                </p>

                              </div>
                            </div>
                          </div>
                        </div>


                        { this.props.parcelInfo.parcel.data.note ?
                          <div className="note-from-warehouse">
                            <h4 className="note-label">Note from the Warehouse</h4>

                            <div className="message-wrapper">
                                <div className="arrow-box"></div>
                                <p className="message"><span className="open-quote">&ldquo;</span> {this.props.parcelInfo.parcel.data.note} <span className="close-quote">&rdquo;</span></p>
                            </div>
                          </div>
                          :
                          null
                       }

                      </div>
                    </div>
                  </div>
                </div>


                <div className="shadow"></div>
              </div>


            </section>
          </div>

          :

          null}

      </div>
    )
  },
});


function mapStateToProps(state) {
  return {
    parcel: state.parcel,
  }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(Object.assign({}, ParcelAction), dispatch);
}
connect(mapStateToProps, mapDispachToProps)(Parcel);

export default Parcel;



/** WEBPACK FOOTER **
 ** ./src/components/DashboardFiles/Parcel.js
 **/